import { PlusIcon } from 'assets/icons';
import styles from './new-album-card.module.scss';

interface NewAlbumCardProps {
  onClick?: () => void;
}

export const NewAlbumCard = ({ onClick }: NewAlbumCardProps) => (
  <button className={styles.card} onClick={onClick} type="button">
    <span className={styles.spacer} />
    <PlusIcon className={styles.plus} />
    <span className={styles.label}>New Album</span>
  </button>
);
